// extracted by mini-css-extract-plugin
export var dividerContainer = "_8n-0";
export var line = "_8n-1";